<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (device of devices | async; track trackBy(device)) {
      <lcs-option [value]="device" id="lcs-option-id-{{ device.deviceId }}">
         {{ getDisplay(device) }}
      </lcs-option>
      }
   </div>
</ng-template>
